<script>
import { clientMethods, masterMethods, employeeMethods } from '@/state/helpers';
import { checkPermission } from '@/utils/handlers';

import Layout from '@/views/layouts/main';
import appConfig from '@/app.config';
import KeyWordTag from '@/components/KeywordTag/main.vue';
import TableListComponent from '@/components/TableList/main.vue';
import ButtonActiveFilter from '@/components/ButtonColFilter/main.vue';
import Multiselect from '@/components/Multiselect/main.vue';

export default {
    page: {
        title: '直クラ・代理店一覧',
        meta: [{ name: 'description', content: appConfig.description }]
    },
    components: {
        Layout,
        KeyWordTag,
        TableListComponent,
        ButtonActiveFilter,
        Multiselect
    },
    beforeRouteEnter(to, from, next) {
        if (!checkPermission('client.view')) {
            next({ name: 'errorPage' });
        }
        next();
    },
    data() {
        return {
            listData: [],
            form: {
                name: '',
                pic: ''
            },
            has: {
                sale_staff: ''
            },
            configSelectSaleStaff: {
                trackBy: 'id',
                label: 'name'
            },
            configKeyword: {
                arrayTag: [],
                placeholder: '会社名　担当者　会社名(カナ)　電話番号　郵便番号　都道府県　住所　URL',
                isShowLable: true
            },
            configTable: {
                widthAction: 200,
                headers: [
                    {
                        label: '会社名',
                        width: 500
                    },
                    {
                        label: '会社名(カナ)',
                        width: 400
                    },
                    {
                        label: '実施中キャンペーン数',
                        width: 300
                    }
                ]
            },
            configPage: {
                total: 0,
                limit: 30,
                page: 1
            },
            listPLSale: [],
            checkShowFilter: false,
            isLoading: false,
            arrRoleClient: ['client.view', 'client.edit'],

            isActive: true,
            heightSizeTable: ''
        };
    },
    watch: {},
    mounted() {
        this.getList();
        this.getListMasterPLSale();
    },

    methods: {
        checkPermission,
        ...masterMethods,
        ...clientMethods,
        ...employeeMethods,
        handleShowFilter() {
            this.checkShowFilter = !this.checkShowFilter;
        },

        async getListMasterPLSale() {
            try {
                const dataRes = await this.listMaster('campaign/common-user');
                this.listPLSale = dataRes['sale'];
            } catch (error) {
                console.log('error', error);
            }
        },
        goToEdit(path, item) {
            this.$router.push({ path: path, query: { id: item.id } });
        },
        getQueryString() {
            let query = [`page=${this.configPage.page}`, `limit=${this.configPage.limit}`, `sorts[id]=desc`];
            let copyHas = Object.assign({}, this.has);
            copyHas.sale_staff = copyHas.sale_staff?.id ?? null;
            if (this.checkShowFilter) {
                if (this.form) {
                    for (const [key, value] of Object.entries(this.form)) {
                        if (key && value) query.push(`search[${key}]=${encodeURIComponent(value)}`);
                    }
                }
                if (copyHas) {
                    for (const [key, value] of Object.entries(copyHas)) {
                        if (key && value) query.push(`has[${key}]=${encodeURIComponent(value)}`);
                    }
                }
            } else {
                if (this.configKeyword.arrayTag.length > 0) {
                    query.push(`q=${this.configKeyword.arrayTag.toString()}`);
                }
            }

            return query.join('&');
        },
        getList() {
            this.isLoading = true;
            let query = this.getQueryString();
            this.listClient(query).then((data) => {
                this.listData = data.data;
                this.configPage.total = data._metadata.total;
                this.configPage.limit = data._metadata.limit * 1;
                if (!this.listData.length && this.configPage.page !== 1) {
                    this.configPage.page = 1;
                    this.getList();
                } else {
                    this.isLoading = false;
                }
            });
        },

        search() {
            let data = {
                form: this.form,
                q: this.q,
                has: this.has,
                filter: this.configKeyword.arrayTag
            };
            localStorage.setItem('client', JSON.stringify(data));
            this.getList();
        },
        clear() {
            this.form = {
                name: '',
                pic: ''
            };
            this.q = '';
            this.has = {
                sale_staff: ''
            };
            this.configKeyword.arrayTag = [];
            let data = {
                form: this.form,
                filter: this.configKeyword.arrayTag,
                has: this.has
            };
            localStorage.setItem('client', JSON.stringify(data));
            this.getList();
        }
    }
};
</script>

<template>
    <Layout>
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-header d-flex" style="gap: 0.5rem">
                        <h3 class="mb-0 title--screen">直クラ・代理店検索</h3>
                        <div class="ml-auto">
                            <ButtonActiveFilter
                                :active.sync="isActive"
                                @sizeHeight="(height) => (heightSizeTable = height)"
                                :smallCol="577"
                                :largeCol="53.9"
                            />
                        </div>
                    </div>
                    <div v-if="isActive" class="card-body position-relative">
                        <div class="row justify-content-center">
                            <div class="col-sm-6 position-static">
                                <form class="needs-validation" autocomplete="off">
                                    <div v-if="!checkShowFilter" class="row form-group">
                                        <div class="col-sm-12">
                                            <KeyWordTag :keyword="form.keywords" :config="configKeyword" class="flex-fill" />
                                        </div>
                                    </div>
                                    <div v-if="checkShowFilter">
                                        <div class="form-group row">
                                            <label class="col-sm-3" for="validationCustom05">会社名</label>
                                            <div class="col-sm-9">
                                                <input id="validationCustom05" v-model="form.name" type="text" class="form-control" />
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-sm-3" for="validationCustom05">PL営業担当</label>
                                            <div class="col-sm-9">
                                                <Multiselect
                                                    :id="`select-sale-staff`"
                                                    :value.sync="has.sale_staff"
                                                    :options="listPLSale"
                                                    :config.sync="configSelectSaleStaff"
                                                />
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-sm-3" for="validationCustom05">エンドクライアント担当名</label>
                                            <div class="col-sm-9">
                                                <input id="validationCustom05" v-model="form.pic" class="form-control" />
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div class="text-center mt-4">
                                        <button type="button" @click="clear()" class="btn btn-common btn-outline-primary">
                                            <i class="ri-restart-line"></i>{{ $t('btn.clear') }}
                                        </button>
                                        <button type="button" @click="search()" class="btn btn-common btn-primary ml-3">
                                            <i class="ri-search-line"></i>{{ $t('btn.search') }}
                                        </button>
                                        <button type="button" @click="handleShowFilter" class="btn btn-common filter btn-outline-primary">
                                            <i class="ri-equalizer-line"></i>絞り込み条件を表示
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card mb-0">
                    <div class="card-header">
                        <h3 class="mb-0 title--screen">
                            直クラ・代理店検索結果 <span>件数（{{ configPage.total }})</span>
                        </h3>
                    </div>
                    <div class="card-body">
                        <TableListComponent
                            :heightTable="heightSizeTable"
                            :config="configTable"
                            :dataList="listData"
                            :isLoading="isLoading"
                            :configPage.sync="configPage"
                            :stickyAction="true"
                            @onChangePage="getList()"
                        >
                            <template #row="{ row }">
                                <tr @dblclick="goToEdit('/client/form/view', row)">
                                    <td>
                                        <div class="el-table__cell text-left">
                                            <a href="javascript:void(0)" @click="goToEdit('/client/form/view', row)">{{ row.name }}</a>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="el-table__cell text-left">
                                            {{ row.kana_name ? row.kana_name : '' }}
                                        </div>
                                    </td>
                                    <td>
                                        <div class="el-table__cell text-left">
                                            <a
                                                href="javascript:void(0)"
                                                @click="
                                                    $router.push({
                                                        path: '/campaign/list',
                                                        query: { client_id: row.id }
                                                    })
                                                "
                                                >({{ row.campaigns_count }})</a
                                            >
                                        </div>
                                    </td>

                                    <td class="sticky_action text-left" style="z-index: 15">
                                        <div class="el-table__cell text-left">
                                            <a
                                                href="javascript:void(0)"
                                                class="btn btn-common-sml btn-info mr-2"
                                                @click="goToEdit('/client/form/view', row)"
                                                ><i class="ri-file-list-2-line"></i>詳細</a
                                            >
                                            <a
                                                v-if="checkPermission(arrRoleClient[1])"
                                                href="javascript:void(0)"
                                                class="btn btn-common-sml btn-primary mr-2"
                                                @click="goToEdit('/client/form', row)"
                                                ><i class="ri-edit-box-line"></i>編集</a
                                            >
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </TableListComponent>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<style lang="scss" scoped></style>
